const APEX_HOST = "vacwork.app";
const PRODUCTION_ORIGIN = "https://www.vacwork.app";
const LOCAL_ORIGIN = "http://localhost:3000";
const TRAILING_SLASH = /\/$/;

type AppBaseUrlEnvironment = {
  host?: string;
  NODE_ENV?: string;
  VERCEL_ENV?: string;
  VERCEL_URL?: string;
};

function toOrigin(host: string): string {
  if (host.startsWith("http://") || host.startsWith("https://")) {
    return host.replace(TRAILING_SLASH, "");
  }
  if (host.includes("localhost")) {
    return LOCAL_ORIGIN;
  }
  return `https://${host}`;
}

export function resolveAppBaseUrl(environment: AppBaseUrlEnvironment): string {
  if (environment.host) {
    const origin = toOrigin(environment.host);
    if (new URL(origin).hostname === APEX_HOST) {
      return PRODUCTION_ORIGIN;
    }
    return origin;
  }

  if (environment.NODE_ENV === "development") {
    return LOCAL_ORIGIN;
  }

  if (environment.VERCEL_ENV === "preview" && environment.VERCEL_URL) {
    return toOrigin(environment.VERCEL_URL);
  }

  return PRODUCTION_ORIGIN;
}

export function getAppBaseUrl(host?: string): string {
  return resolveAppBaseUrl({
    host,
    NODE_ENV: process.env.NODE_ENV,
    VERCEL_ENV: process.env.VERCEL_ENV,
    VERCEL_URL: process.env.VERCEL_URL,
  });
}

export function getAppUrl(path: string, host?: string): string {
  const origin = getAppBaseUrl(host);
  return `${origin}${path.startsWith("/") ? path : `/${path}`}`;
}
